import { render, staticRenderFns } from "./otelkategori.vue?vue&type=template&id=6fcad0d4&"
import script from "./otelkategori.vue?vue&type=script&lang=js&"
export * from "./otelkategori.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports